import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-creator-web';
import {
  gray45,
  black,
  spacer12,
  spacer32,
} from '@spotify-internal/encore-foundation';

const HeaderContainer = styled.div`
  align-items: baseline;
  border-bottom: 1px solid ${black};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${spacer32};
  padding-bottom: ${spacer12};
`;

const HeaderTitleText = styled(Type.h1).attrs({
  condensed: true,
  variant: Type.heading4,
  weight: Type.bold,
})``;

const DataTitleText = styled(Type.p).attrs({
  color: gray45,
  condensed: true,
  variant: Type.cta4,
})``;

const StatsSubHeader = React.memo(props => {
  return (
    <HeaderContainer>
      <HeaderTitleText> {props.title} </HeaderTitleText>
      <DataTitleText> {props.dataTitle} </DataTitleText>
    </HeaderContainer>
  );
});

StatsSubHeader.propTypes = {
  title: PropTypes.string.isRequired,
  dataTitle: PropTypes.string.isRequired,
};

/* eslint-disable-next-line import/no-default-export */
export default StatsSubHeader;
